import React from "react";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { CustomTooltip } from "../../consts.js";
import { useNavigate } from "react-router-dom";
import Utils from "../../utils.js";
import FeatherIcon from "feather-icons-react";
import SettingHeader from "./setting-header.jsx";
import CreateCompanyComponent from "./create-company.jsx";
import { Grid, IconButton } from "@mui/material";
import { listUsersInGroupAPI } from "../../services/group.js";
import TableComponent from "../../components/table/list.jsx";
import { ADMIN_GROUP_NAME } from "../../helpers/constant.js";

function Admin() {
    let navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [newCampDiag, setNewCampDiag] = React.useState(false);
    const [selectedTab] = React.useState("Companies");
    const [isAdmin, setIsAdmin] = React.useState(false);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [spinner, setSpinner] = React.useState(false);

    async function countUsers(company) {
        const response = await listUsersInGroupAPI({
            GroupName: company.internalname,
            Limit: 60,
        });
        company.users = response.Users.length;
        return company;
    }

    async function getCompanyData() {
        Utils.sendProgressBar(true);
        setSpinner(true);
        const userGroups = await Utils.getUserGroupFromCognito();

        // Check if user groups include "admin"
        if (userGroups.includes("admin")) {
            setIsAdmin(true);
        } else {
            console.log("Not a admin user");
            navigate("/"); // Exit if not an admin
            return;
        }

        const companyData = await Utils.genericList("listCompanies", {
            limit: 1000,
        });
        const companies = companyData.data.listCompanies.items;

        const CompanyListWithUserCounts = await Promise.all(companies.map(countUsers));
        for (const element of CompanyListWithUserCounts) {
            if(!element.contact) {
                element.contact = "";
            }
        }

        setData(CompanyListWithUserCounts);

        setSpinner(false);
    }

    React.useEffect(() => {
        if (!dataLoaded) {
            const fetchData = async () => {
                await getCompanyData(); // Your async data fetching function
                setDataLoaded(true); // Mark data as loaded
            };
            fetchData();
        }

        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [dataLoaded]);

    // define table headers
    const columns = [
        {
            label: "Company Name",
            key: "name",
            sortable: true,
            renderItem: (row) => row.name || "-",
        },
        {
            label: "Contact Name",
            key: "contact",
            sortable: true,
            renderItem: (row) => row.contact || "-",
        },
        {
            label: "Email",
            key: "email",
            sortable: true,
            renderItem: (row) => row.email || "-",
        },
        {
            label: "Status",
            key: "status",
            sortable: false,
            renderItem: (row) => (<Chip
                label={row.status === "active" ? "Active" : "Inactive"}
                color={row.status === "active" ? "success" : "info"}
            />)
        },
        {
            label: "# Users",
            key: "users",
            sortable: true,
            renderItem: (row) => row.users || "-",
        },
        // {
        //     label: "Usage",
        //     key: "usage",
        //     sortable: false,
        //     renderItem: (row) => row.usage || "-",
        // },
        {
            label: "Edit",
            key: 'edit',
            sortable: false,
            renderItem: (row) => (row.email !== ADMIN_GROUP_NAME && <CustomTooltip title={"Edit"}>
                <IconButton
                    aria-label="Edit"
                    size="small"
                    color="inherit"
                    onClick={() =>
                        navigate("/edit-company?id=" + row.id)
                    }
                >
                    <FeatherIcon icon="edit-2" size={20} />
                </IconButton>
            </CustomTooltip>)
        }
    ];

    const headerActionButtons = () => {
        return (
            <Button
                variant="contained"
                onClick={() => setNewCampDiag(true)}
                startIcon={<FeatherIcon icon="plus-circle" size={20} />}
            >
                Create Company
            </Button>
        )
    }

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <SettingHeader title={"Companies"} selectedTab={selectedTab} />
            <Grid
                className="vocalysed-home-upadted admin-user"
                container
                spacing={0}
                direction="column"
                flexWrap="nowrap"
                flexGrow={1}
                paddingTop={2}
                paddingX={3}
                paddingBottom={3}
                overflow="auto"
            >
                <TableComponent
                    headerActionButtons={headerActionButtons}
                    spinner={spinner}
                    data={data}
                    columns={columns}
                    pagination={true}
                    searchKeys={["name", "email", "contact"]}
                    noDataMessage={"No companies found."}
                />
            </Grid>

            {/* Create Company Modal */}
            <CreateCompanyComponent
                open={newCampDiag}
                onClose={async (inp) => {
                    if (inp === null) setNewCampDiag(false);
                    else {
                        getCompanyData();
                        setNewCampDiag(false);
                    }
                }}
            />
        </Grid>
    );
}

export default Admin;
